module.exports = __webpack_public_path__ + "img/suriname.1895892f.png";